import clsx from 'clsx'
import { CompanyLogo, LogoNames } from './CompanyLogo'

export function TightLogoCloud() {
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-4 text-white">
      <CompanyLogo key={'clickUp'} name={'clickUp'} />
      <CompanyLogo key={'substack'} name={'substack'} />
      <CompanyLogo key={'vimeo'} name={'vimeo'} />
    </div>
  )
}

export function LogoCloud({
  title = 'Trusted by world class data teams.',
  subtitle = 'From next-gen startups to established enterprises.',
}) {
  const companies: LogoNames[] = [
    'clickUp',
    'substack',
    'vimeo',
    'cargurus',
    'intercom',
    'chiliPiper',
    'videoAmp',
    'goPuff',
    'beautyPie',
    'super',
    'noths',
    'tmm',
    'upEquity',
    'flipsideCrypto',
    // 'software',
    // 'clair',
    'ritual',
    // 'tails',
    // "sunday",
  ]
  return (
    <div
      className="mb-12 flex w-full flex-col items-center overflow-hidden"
      id="logo"
    >
      {title && (
        <h2 className="text-center text-xl font-bold tracking-tight text-slate-400">
          {title}
        </h2>
      )}
      {subtitle && (
        <h2 className="bg-gradient-to-r from-indigo-200 via-sky-400 to-indigo-200 bg-clip-text pt-2 text-center text-xl font-bold tracking-tight text-white">
          {subtitle}
        </h2>
      )}
      <LogoCarousel
        companies={companies.slice(0, Math.floor(companies.length / 2))}
        animationDirection="left"
      />
      <LogoCarousel
        companies={companies.slice(Math.floor(companies.length / 2))}
        animationDirection="right"
      />
    </div>
  )
}

function LogoCarousel({ companies, animationDirection }: { companies: LogoNames[], animationDirection: 'left' | 'right' }) {
  return (
    <div className="no-wrap flex w-full max-w-6xl [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)]">
      <ul
        className={clsx(
          'animate-infinite-scroll flex w-fit flex-nowrap items-center pt-12 text-white',
          animationDirection === 'left'
            ? 'direction-normal'
            : 'direction-reverse'
        )}
      >
        {companies.map((company) => (
          <li key={company} className="shrink-0 pr-20">
            <CompanyLogo key={company} name={company} />
          </li>
        ))}
      </ul>
      <ul
        className={clsx(
          'animate-infinite-scroll flex w-fit flex-nowrap items-center pt-12 text-white',
          animationDirection === 'left'
            ? 'direction-normal'
            : 'direction-reverse'
        )}
      >
        {companies.map((company) => (
          <li key={company} className="shrink-0 pr-20">
            <CompanyLogo key={company} name={company} />
          </li>
        ))}
      </ul>
    </div>
  )
}
